import { DisabledPrompt, Link, useRoute, useUIState } from "@bcm-dev/bcms-vite";
import { TransferTransaction } from "model";

import CustomTableAccordion, { CustomTableContent, CustomTableToggle, useCustomTableAccordion } from "components/custom-ui/CustomTableAccordion";
import { FormContainer, FormRowView, TableColumnContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { UICheckbox } from "components/ui";
import { SVGAsset } from "res";
import MobileScheduledTransfersTable from '../MobileScheduledTransfersTable';
import "./styles.css";
import "./mobile.css";


export default function ScheduledTransfersPage(props) {
    let transfers = props.transfers
    ? props.transfers
    : TransferTransaction.initAll().filter(item => item.id !== undefined).filter(transfer => transfer.status === "scheduled", []);
transfers = transfers.sort((a,b)=>{
       if( a.date.diff() < b.date.diff())
        return -1;
       if( a.date.diff() > b.date.diff())
        return 1;
       return 0;
})
    return (
    <div className="scheduled-transfers-page">
        <div className="rejected-and-canceled-transfers-checkbox-container">
            <DisabledPrompt>
                <UICheckbox label={ `Show Rejected and Canceled Transfers` } />
            </DisabledPrompt>
        </div>
        <div className="show-on-desktop">
            <ScheduledTransfersTable transfers={ transfers } />
        </div>
        <MobileScheduledTransfersTable transfers={ transfers } />
    </div>
    );
}

function ScheduledTransfersTable(props) {
  
    let transfers = props.transfers ?? [];
    transfers = transfers.sort((a,b)=>{
        if( a.onDate.diff() < b.onDate.diff())
         return -1;
        if( a.onDate.diff() > b.onDate.diff())
         return 1;
        return 0;
 })
  
    const transferRows = transfers.map(transfer => {
        return <ScheduledTransfersTableItem key={ `Scheduled_Transfers_${ transfer.id }` } transfer={ transfer } />
    }, []);

    return (
        <TableView className="scheduled-transfers-table">
            <TableColumnContainer className="scheduled-transfers-header">
                <th>&nbsp;</th>
                <th className="text-left">
                    From
                    <DisabledPrompt>
                        <SVGAsset id="SortIcon" className="sort-icon clickable" />
                    </DisabledPrompt>
                </th>
                <th className="text-left">
                    To
                    <DisabledPrompt>
                        <SVGAsset id="SortIcon" className="sort-icon clickable" />
                    </DisabledPrompt>    
                </th>
                <th className="text-left">
                    Frequency
                    <DisabledPrompt>
                        <SVGAsset id="SortIcon" className="sort-icon clickable" />
                    </DisabledPrompt> 
                </th>
                <th className="text-left">
                    Next Transfer
                    <DisabledPrompt>
                        <SVGAsset id="ArrowUpIcon" className="sort-icon clickable" />
                    </DisabledPrompt> 
                </th>
                <th className="text-right">
                    Amount
                    <DisabledPrompt>
                        <SVGAsset id="SortIcon" className="sort-icon clickable" />
                    </DisabledPrompt> 
                </th>
            </TableColumnContainer>         

            {transferRows}          
        </TableView>
    )
}

function ScheduledTransfersTableItem(props) {
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();
    const { key, config } = useUIState(`Accordion_${ transfer.id }`, { isActive: false });

    return (
        <CustomTableAccordion activeClass="open-custom-transaction-accordion" state={ config.isActive }>
            <ScheduledTransfersTableItemToggle transfer={ transfer } />
            <ScheduledTransfersTableItemContent transfer={ transfer } />
        </CustomTableAccordion>
    )
}

function ScheduledTransfersTableItemToggle(props) {
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();
    const { state } = useCustomTableAccordion();
    let frequencyMessage = "One time";

    if(transfer.schedule === "Recurring") {
        frequencyMessage = transfer.frequency;
    }
    
    return (
        <CustomTableToggle>
            <tr className="clickable">
                <TableItemView className="expand-row-chevron text-center" data-point={ `Scheduled_Transfer_Arrow_${ transfer.id }` }>
                    <SVGAsset id={ state ? "DownChevronIcon" : "RightChevronIcon" } className="icon" />
                </TableItemView>

                <TableItemTextView className="text-left expanded" text={ transfer.from?.nickname +" - " + transfer.from?.number } />
                <TableItemTextView className="text-left expanded" text={ transfer.to?.nickname +" - " + transfer.to?.number } />
                <TableItemTextView className="text-left expanded" text={ frequencyMessage } />
                <TableItemTextView className="text-left expanded" text={ transfer.onDate.format("m/d/Y") }/>
                <TableItemTextView className="text-right expanded amount-column" text={ transfer.amount.format() }  />
            </tr>
        </CustomTableToggle>
    )
}

function ScheduledTransfersTableItemContent(props) {
    const navigate = useRoute();
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();

    const onEditTransferClick = id => () => {
        navigate(`/transfers/0/${ id }`);
    };

    return (
        <CustomTableContent>
            <tr>
                <td className="scheduled-transfers-table-item" colSpan="6">
                    <div className="flex-container">
                        <p className="flex-width">TRANSFER DETAILS</p>         
                        <CustomTableToggle>
                            <SVGAsset id="CloseX" className="set-width clickable" />
                        </CustomTableToggle>          
                    </div>

                    <FormContainer>
                        <FormRowView text="Type">
                            <p>Internal Transfer</p>
                        </FormRowView>
                        
                        <FormRowView text="Deliver By">
                            <p>{ transfer.onDate.format("m/d/Y") }</p>
                        </FormRowView>
                        
                        <FormRowView text="Schedule">
                            <p>Once on { transfer.onDate.format("m/d/Y") }</p>
                        </FormRowView>
                        
                        <FormRowView text="Note">
                            <p>{ transfer.note }</p>
                        </FormRowView>
                        
                        <FormRowView className="link-container">
                                <a className="clickable" onClick={ onEditTransferClick(transfer.id) }>
                                    <span data-point={ `Scheduled_Transfer_Edit_${ transfer.id }` }>Edit Transfer</span>
                                </a>
                        </FormRowView>
                        
                        <FormRowView className="link-container">
                            <DisabledPrompt>
                                <Link>
                                    <span data-point={ `Scheduled_Transfer_Cancel_${ transfer.id }` }>Cancel Transfer</span>
                                </Link>
                            </DisabledPrompt>
                        </FormRowView>
                    </FormContainer>
                </td>
            </tr>
        </CustomTableContent>
    )
}